<!-- 获取验证码 -->
<template>
  <span
    :class="`verification ${langKey === 'en' ? 'verificationEn' : ''} ${isCanGetPhoneCode || isdisable ? 'verification-wait' : ''}`"
  >
    <van-button
      :type="btntype"
      :disabled="isCanGetPhoneCode || isdisable || getCodeLoading"
      :class="classvalue"
      @click="checkPhoneNo"
    >
      <span
        class="mgetCode-text"
      >{{ isCanGetPhoneCode ? phoneCodeTime + 's后重新获取' : '获取验证码' }}</span>
    </van-button>
  </span>
</template>
<script>
import { apiGet } from '@/services'

export default {
  name: 'getVerifyCode',
  props: {
    phone: {
      // 输入手机号
      type: String,
      default: ''
    },
    phoneAreaCode: {
      // 输入区号
      type: String,
      default: ''
    },
    type: {
      // 获取验证码类型：0、登录验证码，1、找密码，2、支付，3、其他，4、注册
      type: Number,
      default: -1
    },
    btntype: {
      // 注意不能驼峰写法
      type: String,
      default: 'text'
    },
    classvalue: {
      // 设置当前类名，注意添加类样式为全局或局部
      type: String,
      default: 'defaultColor'
    },
    isdisable: {
      // 是否禁用，用于实名认证通过后表单禁止修改
      type: Boolean,
      default: false
    },
    isSendPhone: {
      // 是否需要发送手机号来获取验证码，默认是需要，已更改为URL不一样
      type: Boolean,
      default: true
    },
    baidutext: {
      // 判断是否是百度埋点注册统计，默认为空不添加百度统计
      type: String,
      default: ''
    }
  },
  data() {
    return {
      // 是否在等待获取二维码
      getCodeLoading: false,
      isCanGetPhoneCode: false,
      phoneCodeTimeObj: '', // 验证码定时器对象
      phoneCodeTime: 60, // 设置获取验证码倒计时定时器秒数
      langKey: this.$store.state.locale
    }
  },

  mounted() {
    clearInterval(this.phoneCodeTimeObj)
    this.isCanGetPhoneCode = false
  },

  methods: {
    checkPhoneNo() {
      this.$emit('checkPhone', this.getCode.bind(this))
    },
    getCode() {
      if (!this.phone && this.isSendPhone) {
        // 不需要校验手机号的情况
        this.$notify.warning(this.$t('app.validator.noPhone'))
      } else {
        const url = 'partner/open/sendPhoneCode'
        const data = { phone: this.phone}
        this.getCodeLoading = true
        apiGet(url, data)
          .then(res => {
            if (res.code === '0000') {
              this.$notify.success(res.msg)
              this.isCanGetPhoneCode = true
              this.$emit('send')
              this.setintervalPhoneCode()
            } else {
              this.$notify.error(res.msg)
            }
          })
          .then(() => {
            this.getCodeLoading = false
          })
      }
    },

    // 设置定时器，获取验证码
    setintervalPhoneCode() {
      this.phoneCodeTimeObj = setInterval(() => {
        if (this.phoneCodeTime === 0) {
          clearInterval(this.phoneCodeTimeObj)
          this.isCanGetPhoneCode = false
          this.phoneCodeTime = 60
          return
        }
        this.phoneCodeTime--
      }, 1000)
    }
  },

  distroyed() {
    clearInterval(this.phoneCodeTimeObj)
    this.isCanGetPhoneCode = false
  }
}
</script>
<style lang="less" scoped>
.defaultColor {
  color: #5C288D;
  background: transparent;
  border: 0.5px solid #5c288d;
}
.verification{
  position: relative;
}
/deep/.van-button {
  padding: 0 12px;
  height: 22px;
  font-size: 12px;
  line-height: 22px;
  color: #5C288D;
  border-radius: 4px;
}
.verification-wait {
  /deep/.van-button {
    color:  #666666;
  }
}
.van-button--disabled{
  border: 0.5px solid #9f9f9f;
  .van-button{
    color: #666666;
  }
}
</style>
